<template>
  <div class="car-details" v-loading="oLoading.detail && this.id">
    <QS-h3-title>
      <template slot="title">{{ pageTitle }}</template>
      <template slot="right">
        <!-- $route.query.tabType 判断是否在车辆详情中 $route.query.tabType有值的话代表在否则不在 -->
        <!-- isShowEdit -->
        <el-button
          v-if="isShowEdit && !$route.query.tabType"
          @click="editHandle"
          type="primary"
          size="small"
          class="float-right"
        >编辑</el-button>
        <el-button
          v-if="$route.query.tabType"
          slot="right"
          @click="$router.back()"
        >返回</el-button>
      </template>
      <div class="splitline" />
    </QS-h3-title>
    <div>
      <section class="item">
        <QS-h4-title title="车辆信息" />
        <column-box
          :source="carInfoVo"
          :list="carInfoList"
          :labelWidth="130"
        ></column-box>
      </section>
      <section class="item">
        <QS-h4-title title="交接信息" />
        <column-box
          :source="stockInfoVo"
          :list="stockKeyList"
          :labelWidth="130"
        ></column-box>
      </section>

      <section>
          <QS-h4-title title="验车照片" />
          <div class="upload-box">
            <p class="upload-box__title">车况照片</p>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">门店上传</p>
              <UploadCommon
                v-if="photoPlus.length > 0"
                :fileList="photoPlus"
                :limit="20"
                :multiple="true"
                :sizeType="4"
                fileTitleWidth="240px"
                :isAlone="false"
                :readonly="true"
                commonUpload
                group="order"
                code="order_vehicle_pic"
              />
              <div v-else>--</div>
            </div>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">司机上传</p>
              <UploadCommon
                v-if="confirmPhoto.length > 0"
                :fileList="confirmPhoto"
                :limit="20"
                :multiple="true"
                :sizeType="4"
                fileTitleWidth="240px"
                :isAlone="false"
                :readonly="true"
                commonUpload
                group="order"
                code="order_vehicle_pic"
              />
              <div v-else>--</div>
            </div>
          </div>
          <div class="upload-box">
            <p class="upload-box__title">验车交接文件照</p>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">门店上传</p>
              <UploadCommon
                v-if="inspectionAttachmentPlus.length > 0"
                :fileList="inspectionAttachmentPlus"
                :limit="10"
                :multiple="true"
                :sizeType="4"
                fileTitleWidth="240px"
                :isAlone="false"
                :readonly="true"
                commonUpload
                group="vehicle"
                code="vehicle_inspection_file"
              />
              <div v-else>--</div>
            </div>
          </div>
        </section>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getOutInDetailsSensitive } from '@/api/domain/cars'
import CARDICT from '@/store/dict/carDict.js'
import SelectOption from '@/store/dict/selectOptionDict'

export default {
  data() {
    return {
      oLoading: {
        detail: false,
      },
      id: '',
      carId: '',
      stockId: '',
      stockInfoVo: {},
      carInfoVo: {},
      rentOrderVO: {},
      stockKeyList: [
        { key: 'actualTakeOverName', name: '提车人姓名' },
        { key: 'actualTakeOverTel', name: '提车人联系电话' },
        { key: 'managerName', name: '交接车管' },
        { key: 'displayMile', name: '表显里程' },
        { key: 'remainingReserves', name: '剩余电量/油量' },
        { key: 'takeOverTime', name: '验车完成时间' },
        { key: 'hasKey', name: '车钥匙' },
        { key: 'hasCarLicense', name: '行驶证' },
        { key: 'remarks', name: '备注', clone: true },
      ],
      carInfoList: [
        { key: 'plateNo', name: '车牌号' },
        { key: 'brandName', name: '品牌' },
        { key: 'seriesName', name: '车系' },
        { key: 'name', name: '车型' },
        { key: 'customerName', name: '提车人姓名' },
        { key: 'contactTel', name: '提车人手机号' },
        { key: 'vin', name: '车架号（VIN码）' },
      ],
      payDataList: [],
      payDataListSlice: [],
      type: '',
      pageTitle: '',
      // 验车交接文件
      inspectionAttachmentPlus: [],
      // 车辆相关照片-门店上传
      photoPlus: [],
      // 车辆相关照片-司机上传
      confirmPhoto: [],
    }
  },
  computed: {
    // 出入库状态 0待处理/1已完成/2已作废
    outInState() {
      if (this.stockInfoVo) {
        if (this.stockInfoVo.state || this.stockInfoVo.state === 0) {
          return this.stockInfoVo.state
        } else {
          return 2 // 默认是作废不显示编辑按钮
        }
      } else {
        return 2 // 默认是作废不显示编辑按钮
      }
    },
    // 编辑按钮是否显示
    isShowEdit() {
      const { tab } = this.$route.query
      return (
        this.judgePermission('carOperationOutInEdit') &&
        this.outInState !== 2 &&
        !tab
      )
    },
  },
  created() {
    const { id } = this.$route.query
    if (id) {
      this.id = parseInt(id)
      this.getOutInDetails()
    } else {
      this.$message.error('缺少ID参数')
    }
  },
  methods: {
    async getOutInDetails() {
      this.oLoading.detail = true
      const { code, data } = await getOutInDetailsSensitive({
        id: this.id,
      })

      if (code === 1) {
        this.carId = data.carInfoVo.carId
        this.stockId = data.stockInfoVo.stockId

        // hasCarLicense-有无行驶证 & hasKey有无钥匙 1-有、0-无
        Object.keys(data.stockInfoVo).forEach((key) => {
          if (key === 'hasCarLicense' || key === 'hasKey') {
            if (
              data.stockInfoVo[key] !== null &&
              data.stockInfoVo[key] !== undefined
            ) {
              data.stockInfoVo[key] = data.stockInfoVo[key] === 0 ? '无' : '有'
            }
          }
        })

        this.stockInfoVo = { ...data.stockInfoVo }
        // 处理车况照片-门店上传
        const photoPlusObj = {
          remark: [],
          urlList: [],
        }
        data.stockInfoVo.photoPlus?.forEach((item) => {
          if (item.remark) {
            photoPlusObj.remark.push(item.remark)
          }
          if (Array.isArray(item.urlList) && item.urlList.length) {
            item.urlList.forEach((url) => {
              photoPlusObj.urlList.push({
                url,
              })
            })
          }
        })
        this.photoPlus = photoPlusObj.urlList
        // 处理验车交接文件
        const inspectionAttachmentPlusObj = {
          remark: [],
          urlList: [],
        }
        data.stockInfoVo.inspectionAttachmentPlus?.forEach((item) => {
          if (item.remark) {
            inspectionAttachmentPlusObj.remark.push(item.remark)
          }
          if (Array.isArray(item.urlList) && item.urlList.length) {
            item.urlList.forEach((url) => {
              inspectionAttachmentPlusObj.urlList.push({
                url,
              })
            })
          }
        })
        this.inspectionAttachmentPlus = inspectionAttachmentPlusObj.urlList
        // 处理司机上传
        if (data.stockInfoVo.confirmPhoto) {
          const confirmPhotoList = JSON.parse(data.stockInfoVo.confirmPhoto)
          this.confirmPhoto = confirmPhotoList.map((item) => {
            return {
              url: item,
            }
          })
        }
        this.stockInfoVo.displayMile = this.stockInfoVo.displayMile
          ? `${this.stockInfoVo.displayMile} 公里`
          : ''
        this.type = this.stockInfoVo.type
        this.stockInfoVo.type = CARDICT.OUT_INT_TYPE()[this.stockInfoVo.type]
        this.carInfoVo = { ...data.carInfoVo,
          contactTel: data.rentOrderVO.contactTel,
          customerName: data.rentOrderVO.customerName,
          startDate: `${data.rentOrderVO.effectDate}至${data.rentOrderVO.endDate}`,
          rentCategoryName: data.rentOrderVO.rentCategoryName,
        }
        // 订单信息
        if (data.rentOrderVO) {
          // 订单状态
          this.rentOrderVO = { ...data.rentOrderVO }
          this.rentOrderVO.state =
            SelectOption.leaseOrderState[this.rentOrderVO.state]
        }
        this.payDataList = data.collectionInfoVo
        this.payDataListSlice = data.collectionInfoVo
      } else {
        this.$message.error('获取详情失败')
      }
      this.pageTitle = `${this.stockInfoVo.type || '出入库'}记录详情`
      this.oLoading.detail = false
    },
    // 跳转编辑页面
    editHandle() {
      this.$router.push({
        path: '/vehicle/outInStorage/edit',
        query: {
          stockId: this.stockId,
          orderId: this.$route.query.orderId,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
.imgPhoto {
  width: 80px;
  height: 80px;
  margin: 0 10px 5px 0;
}
.img-item {
  display: flex;
  margin-bottom: 10px;
  .label {
    padding-right: 12px;
    width: 130px;
    text-align: right;
    box-sizing: border-box;
  }
  .content {
    max-width: 480px;
    display: flex;
    flex-wrap: wrap;
    .item {
      margin-left: 16px;
      width: 80px;
      &:nth-child(5n + 1) {
        margin-left: 0;
      }
      &:nth-child(n + 6) {
        margin-top: 6px;
      }
    }
    p {
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #969799;
      line-height: 25px;
      overflow: hidden;
      text-align: center;
    }
  }
}
.lh28 {
  line-height: 28px;
}
.car-details {
  height: 100%;
  .float-right {
    float: right;
  }
  .details-container {
    position: relative;
    height: calc(100% - 80px);
  }
  .file-list {
    padding-left: 0;
    list-style: none;
    li {
      display: flex;
      [class^='el-icon'] {
        width: 20px;
        line-height: 28px;
        color: #2e7eff;
        padding-right: 10px;
      }
      p {
        flex: 1;
        color: #2e7eff;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
.carPhoto-box {
  display: flex;
  margin: 10px 0 0 50px;
  .carPhoto-title {
    width: 130px;
    color: #333;
  }
}
.photo-box {
  .photo-item {
    margin-bottom: 10px;
  }
  .imgPhoto-title {
    width: 40vw;
    word-break: break-all;
  }
}
.upload-box {
  padding-bottom: 10px;
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1D2129;
  }
  &__content {
    &__subtitle {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: #86909C;
    }
  }
}
</style>
